module.exports = __webpack_public_path__ + "img/virtual-server.fcf21a9.svg";